<template>
  <div ref="friendList" class="cpt-skeleton-friend-list friend-scroll-dom">
    <div class="friend-item-skeleton" v-for="i in 20" :key="`friend${i}`">
      <div class="friend-icon-skeleton" :style="{ animationDelay: `${i * 0.5}s` }" />
      <div class="friend-name-skeleton" :style="{ animationDelay: `${0.5 + i * 0.5}s` }"/>
    </div>
  </div>
</template>

<script>
export default {
};
</script>
<style lang="scss">
@import "_css/skeleton.scss";

.cpt-skeleton-friend-list {
  width: 100%;
  //height: calc(100% - 50px);
  height: 100% !important;
  overflow-x: hidden;
  overflow-y: hidden !important;
  flex-shrink: 0;
  .scroll-container {
    margin-right: calc(-280px + 100%);
  }
  .friend-item-skeleton {
    padding: 9px 16px 9px 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .friend-name-skeleton {
      width: 120px;
      height: 16px;
      @include skeleton-background();
      @include skeleton-animation();
      border-radius: 10px;
      margin: 0 0 0 10px;
    }
    .friend-icon-skeleton {
      width: 32px;
      height: 32px;
      flex-shrink: 0;
      border-radius: 50% 50%;
      @include skeleton-background();
      @include skeleton-animation();
    }
  }
}
</style>